
import { useEffect, useState } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { EleStatusDDLAPI, LocationNameELDDLAPI } from '../../Redux/DDLSlice'

export const EleStatusDDL = (props) => {

    const { StatusName, setStatusName, APIFlag, rowData, Flag } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()
    // const [workTypeID, setLocationName] = useState('')

    useEffect(() => {
        const data = {
            Flag: APIFlag,
            M_UserID: UserID,
            token: token
        }
        dispatch(EleStatusDDLAPI({ data }))
    }, [])

    const { StatusData } = useSelector(state => state.EleStatusDDLData)

    useEffect(() => {
        handleStatusNameDDL()
    }, [StatusData])

    const handleStatusNameDDL = () => {
        if (StatusData && StatusData.table && StatusData.table.length > 0) {
            let list = StatusData.table.map((item, index) => ({
                value: item.m_eleC_StatusID,
                label: item.statusName,
            }))
            setStatusName({
                DDL: list,
                ID: Flag === 'Update' ? rowData.active_M_ELEC_StatusID : 0,
                Label: Flag === 'Update' ? rowData.activeStatus : "Select...",
            })
        }
        else {
            setStatusName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label for="" className=""><b>Status Name</b></label>

            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width2"
                isSearchable
                maxMenuHeight={115}
                value={{ value: StatusName.ID, label: StatusName.Label }}
                onChange={(e) => {
                    e ?
                        setStatusName({ ...StatusName, ID: e.value, Label: e.label })
                        :
                        setStatusName({ ...StatusName, ID: 0, Label: "Select..." })

                }}
                options={StatusName.DDL}
            />
        </div>
    )
}